import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Tell us everything")}</Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              {/* Ganti email ke email Datagakure kamu */}
              <a href="mailto:hello@datagakure.com">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Policy")}</Title>
              <Large to="/">{t("Application Security")}</Large>
              <Large to="/">{t("Software Principles")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Empty />
              <Title>{t("Support")}</Title>
              <Large to="/">{t("Technical Documentation")}</Large>
              <Large to="/">{t("SME Help Center")}</Large>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>{t("Address")}</Language>
              <Para>Bandung, West Java</Para>
              <Para>Indonesia</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Lab")}</Title>
              <Large to="/">{t("About")}</Large>
              <Large to="/">{t("Works")}</Large>
              <Large to="/">{t("Research")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("id")}>
                  <SvgIcon
                    src="vec_ind.png"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  // src="DG-logo-rounded.png"
                  src="DGNEW.png"
                  aria-label="homepage"
                  width="40px"
                  height="40px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              {/* Ganti dengan URL profile asli kamu */}
              <SocialLink
                href="https://rizkhita.github.io/"
                src="github.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/in/rizkhita/"
                src="linkedin.svg"
              />
              <SocialLink
                href="https://rizkhita.github.io/"
                src="medium.svg" 
              />
            </FooterContainer>
          </Row>
          <Row justify="center" style={{ paddingTop: "2rem" }}>
             <Para style={{ fontSize: "12px", opacity: 0.5 }}>
                © Datagakure Technical Lab. All rights reserved.
             </Para>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);